export default __webpack_public_path__ + "static/media/1788.79b7c066.png";